import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import FirstStep from "./Step1";
import SecondStep from "./Step2";
import ThirdStep from "./Step3";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import { fetchRegisterData } from "../../redux/actions/confirmInvitationActionCreators";
import { useDispatch, useSelector } from "react-redux";
import { useGoogleLogin } from "@react-oauth/google";
import { requestLogin } from "../../redux/actions/userActionCreators";
import AuthMedthodeErrorModal from "./AuthMedthodeErrorModal"

const Register = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const registerData = useSelector(
    (state) => state.confirmInvitation.registerData
  );
  const ssoUser = useSelector((state) => state.user.ssoUser);
  const { isAuth } = useSelector((state) => state.user);


  const [data, setData] = useState({ country: "FR" });
  const [step, setStep] = useState(0);
  const [activeStep1, setActiveStep1] = useState(false);
  const [activeStep2, setActiveStep2] = useState(false);
  const [accountType, setAccountType] = useState("");


  const invitationUid = new URLSearchParams(location.search).get(
    "invitation_uid"
  );
  const useStyles = makeStyles(() => ({
    root: {
      "& .Mui-completed .MuiStepIcon-root": { color: "#0FB694" },
    },
  }));

    useEffect(() => {
    if (ssoUser?.google_register && ssoUser?.accountType || ssoUser?.google_register && invitationUid) {
      setStep(2);
      setAccountType(ssoUser?.accountType);
    } else if(ssoUser?.google_register && !ssoUser?.accountType) {
      setStep(0)
    }
  }, [ssoUser]);
  const { t } = useTranslation();

  useEffect(() => {
    if (invitationUid && !isAuth) {
      dispatch(fetchRegisterData(invitationUid, history));
    }
  }, [invitationUid]);



  const styles = useStyles();

  useEffect(() => {
    if (invitationUid && Object.keys(registerData).length > 0 && !ssoUser?.google_register) {
      setStep(1);
      setActiveStep1(true);
      setData({
        ...data,
        email: registerData?.email,
        enterprise: registerData?.enterprise,
        firstName: registerData?.first_name,
        lastName: registerData?.last_name,
      });
    }
  }, [invitationUid, registerData, ssoUser]);

  useEffect(()=>{
if(ssoUser?.google_register && accountType==="enterprise") {
  setData({...data, enterprise: ssoUser?.entreprise})
}
  },[accountType, ssoUser])



  const handleStep = () => {
    setStep(step + 1);
  };

  const handleActiveStep1 = (bol) => {
    setActiveStep1(bol);
  };

  const handleActiveStep2 = (bol) => {
    setActiveStep2(bol);
  };

  const handleData = (value) => {
    setData({ ...data, ...value });
  };

  const handeAccountType = (type) => {
    setAccountType(type);
  };


  const login =   useGoogleLogin({
    onSuccess: (codeResponse) =>
      dispatch(
        requestLogin(true, "", "", "", codeResponse, history, accountType, invitationUid )
      ),
    flow: "auth-code",
  });

  return (
    <div>
      {/* <Typography sx={{ color: "rgba(0, 0, 0, 0.4)" }}>
        {t("start_free")}
      </Typography> */}
      <Typography sx={{ mb: 2 }} variant="title1">
        {t("create_account")}
      </Typography>

      <Box sx={{ width: "100%", mt: 5 }}>
        {!ssoUser?.google_register ? (
          <Stepper activeStep={step} className={styles.root}>
            {!invitationUid && (
              <Step>
                <StepLabel
                  sx={{ cursor: "pointer" }}
                  onClick={() => setStep(0)}
                >
                  {t("step_11")}
                </StepLabel>
              </Step>
            )}

            <Step>
              <StepLabel
                sx={{ cursor: "pointer" }}
                type="submit"
                onClick={() => activeStep1 && setStep(1)}
              >
                {invitationUid ? t("step_11") : t("step_22")}
              </StepLabel>
            </Step>
            <Step>
              <StepLabel
                sx={{ cursor: "pointer" }}
                type="submit"
                onClick={() => activeStep2 && setStep(2)}
              >
                {invitationUid ? t("step_22") : t("step_33")}
              </StepLabel>
            </Step>
          </Stepper>
        ) : ssoUser?.google_register && !ssoUser?.accountType && !invitationUid ? (
          <Stepper activeStep={step} className={styles.root}>


            <Step>
              <StepLabel
                sx={{ cursor: "pointer" }}
                type="submit"
                onClick={() => activeStep1 && setStep(0)}
              >
                {t("step_11") }
              </StepLabel>
            </Step>
            <Step>
              <StepLabel
                sx={{ cursor: "pointer" }}
                type="submit"
                onClick={() => activeStep2 && setStep(1)}
              >
                { t("step_22")}
              </StepLabel>
            </Step>
          </Stepper>
        ) : null}
      </Box>

      {ssoUser?.google_register && !ssoUser?.accountType && !invitationUid? (step === 1 ? (
        <ThirdStep
          data={data}
          handleData={handleData}
          accountType={accountType}
          invitationUid={invitationUid}
          ssoUser={ssoUser}
          enterprise={ssoUser?.entreprise}
        />
      )  : (
        <FirstStep
          handeAccountType={handeAccountType}
          handleActiveStep1={handleActiveStep1}
          handleStep={handleStep}
          accountType={accountType}
        />
      ))  : (
        step === 2 ? (
          <ThirdStep
            data={data}
            handleData={handleData}
            accountType={accountType}
            invitationUid={invitationUid}
            ssoUser={ssoUser}
            invitaionEnterprise={registerData?.enterprise}
          />
        ) : step === 1 ? (
          <SecondStep
            handleStep={handleStep}
            data={data}
            handleData={handleData}
            handleActiveStep2={handleActiveStep2}
            invitationUid={invitationUid}
            login={login}
          />
        ) : (
          <FirstStep
            handeAccountType={handeAccountType}
            handleActiveStep1={handleActiveStep1}
            handleStep={handleStep}
            accountType={accountType}
            
          />
        )
      )} 

     <AuthMedthodeErrorModal/>
    </div>
  );
};

export default Register;
